const $blockForms = $('.form-block form');
const $ctaForms = $('.cta-cards form');

if($blockForms.length > 0) {
  setConsentLink($blockForms);
}

if($ctaForms.length > 0) {
  setConsentLink($ctaForms);
}

function setConsentLink($forms) {
  $forms.each(function() {
    if($(this).find('input[data-name="privacy_policy"]').length > 0 && $(this).find('legend').length > 0) {
      let $text = $(this).find('legend').text();
      $text = $text.replace('Integritetspolicy', '<a href="https://upheads.se/upheads-integritets-och-persondatapolicy" target="_blank">Integritetspolicy</a> *');
      $(this).find('legend').html($text);
    }
  });
}